/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Staff_Role_OrganizerInputs */



/**
* | output |
* | --- |
* | "Organizer" |
*
* @param {Tournaments_Lib_Staff_Role_OrganizerInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_staff_role_organizer = /** @type {((inputs?: Tournaments_Lib_Staff_Role_OrganizerInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Staff_Role_OrganizerInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Organisator")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Organisateur")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("主办方")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("主辦人")
	if (locale === "ko") return /** @type {LocalizedString} */ ("주최자")
	return /** @type {LocalizedString} */ ("Organizer")
});